import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f62791e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-footer" }

import { computed, ref, reactive, onMounted } from 'vue';
import { FormInstance } from 'element-plus';
import EDrawer from '@/components/bussiness/e-drawer/index.vue';
import { getUserList } from '@/api/user';
import { accountStatusTextMap, accountStatusColorMap } from '@/config/const/index';
import { getDepartmentText } from '@/utils/index';
import Pagination from '@/components/bussiness/Pagination/Index.vue';
import { getMyAuth } from '@/api/myAuth';
import { useSystemStore } from '@/store';
import AutotrimInput from '@/components/autotrim-input/AutotrimInput.vue';

interface Props {
  drawerVisible: boolean;
  addUserList: VirtualGroup.UserItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'addUserDrawer',
  props: {
    drawerVisible: { type: Boolean, default: false },
    addUserList: { default: () => [] }
  },
  emits: ['update:drawerVisible', 'change'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const systemStore = useSystemStore();

const drawerShow = computed({
  get: () => props.drawerVisible,
  set: (val) => {
    emit('update:drawerVisible', val);
  }
});

const formRef = ref<FormInstance>();
const form = reactive({
  userName: '',
  mobile: '',
  departmentId: ''
});

const paginationObj = reactive({
  pageNum: 1,
  pageSize: 10,
  totalCount: 0
});

const loading = ref(false);
const tableList = ref<VirtualGroup.UserItem[]>([]);

// 获取分页用户列表
const getList = async () => {
  const { pageNum, pageSize } = paginationObj;
  const query = {
    ...form,
    status: 1,
    page: {
      pageNum,
      pageSize
    }
  };
  try {
    const res = await getUserList(query);
    const { code, data } = res || {};
    if (`${code}` === '0') {
      // 处理isAdd 字段
      tableList.value = (data.userList || []).map((user) => {
        const newUser: VirtualGroup.UserItem = { ...user };
        if (innerAddUserList.find((item) => item.uid === user.uid)) {
          newUser.isAdd = true;
        }
        return newUser;
      });
      paginationObj.totalCount = data.page.totalCount;
    }
  } finally {
    loading.value = false;
  }
};

const onReset = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  getList();
};

const departmentList = ref<Basic.DepartmentTreeItem[]>([]);
const treeProps = ref({
  label: 'departmentName',
  children: 'children'
});

// 用来存放已添加的用户
let innerAddUserList: VirtualGroup.UserItem[] = [];

onMounted(async () => {
  innerAddUserList = props.addUserList || [];
  getList();

  const { projectId } = systemStore.projectInfo || {};
  if (typeof projectId !== 'undefined') {
    const res = await getMyAuth(projectId);
    const { code, data } = res;
    if (`${code}` === '0') {
      departmentList.value = data.departmentTree;
      console.log('departmentList:', data.departmentTree);
    }
  }
});
const onAddUser = (user: VirtualGroup.UserItem) => {
  user.isAdd = true;
  innerAddUserList.push(user);
};

const onDelUser = (user: VirtualGroup.UserItem) => {
  const index = innerAddUserList.findIndex((item) => item.uid === user.uid);
  if (index >= 0) {
    user.isAdd = false;
    innerAddUserList.splice(index, 1);
  }
};

const goBack = () => {
  emit('change', innerAddUserList);
  drawerShow.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_e_form_item = _resolveComponent("e-form-item")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_e_form = _resolveComponent("e-form")!
  const _component_e_filter = _resolveComponent("e-filter")!
  const _component_e_table_column = _resolveComponent("e-table-column")!
  const _component_e_status = _resolveComponent("e-status")!
  const _component_e_button = _resolveComponent("e-button")!
  const _component_e_table = _resolveComponent("e-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(EDrawer, {
    modelValue: drawerShow.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((drawerShow).value = $event)),
    direction: "rtl",
    title: "添加用户",
    size: "55%",
    "show-footer": true,
    "show-close": false,
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_e_button, { onClick: goBack }, {
          default: _withCtx(() => [
            _createTextVNode("返回")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_e_filter, {
        "show-reset": "",
        "enter-search": "",
        onReset: _cache[3] || (_cache[3] = ($event: any) => (onReset(formRef.value))),
        onSearch: getList
      }, {
        default: _withCtx(() => [
          _createVNode(_component_e_form, {
            ref_key: "formRef",
            ref: formRef,
            inline: true,
            "label-position": "right",
            model: form,
            "label-width": "80px",
            "show-ellipsis": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_form_item, {
                label: "用户名称",
                prop: "userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(AutotrimInput, {
                    modelValue: form.userName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userName) = $event)),
                    placeholder: "请输入用户名称",
                    clearable: "",
                    onKeyup: _withKeys(getList, ["enter"])
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_e_form_item, {
                label: "手机号",
                prop: "mobile"
              }, {
                default: _withCtx(() => [
                  _createVNode(AutotrimInput, {
                    modelValue: form.mobile,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.mobile) = $event)),
                    placeholder: "请输入手机号",
                    clearable: "",
                    onKeyup: _withKeys(getList, ["enter"])
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_e_form_item, {
                label: "组织",
                prop: "departmentId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tree_select, {
                    modelValue: form.departmentId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.departmentId) = $event)),
                    filterable: "",
                    data: departmentList.value,
                    props: treeProps.value,
                    "node-key": "departmentId",
                    "check-strictly": true,
                    "render-after-expand": false
                  }, null, 8, ["modelValue", "data", "props"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_e_table, {
        data: tableList.value,
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_e_table_column, {
            label: "用户ID",
            prop: "uid",
            "min-width": "150px",
            align: "center"
          }),
          _createVNode(_component_e_table_column, {
            label: "用户名称",
            prop: "userName",
            "min-width": "100px"
          }),
          _createVNode(_component_e_table_column, {
            label: "手机号",
            prop: "mobile",
            "min-width": "150px"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.mobile ? scope.row.mobile.replace(/(\d{3})\d{4}(\d*)/g, '$1****$2') : ''), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_e_table_column, {
            label: "组织",
            prop: "departments",
            "min-width": "200px"
          }, {
            default: _withCtx((scope) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.departments, (item, index) => {
                return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(_unref(getDepartmentText)(item)), 1))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_e_table_column, {
            label: "状态",
            prop: "status",
            "min-width": "100px"
          }, {
            default: _withCtx((scope) => [
              (typeof scope.row.status === 'number')
                ? (_openBlock(), _createBlock(_component_e_status, {
                    key: 0,
                    label: _unref(accountStatusTextMap).get(scope.row.status),
                    type: _unref(accountStatusColorMap).get(scope.row.status)
                  }, null, 8, ["label", "type"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_e_table_column, {
            label: "操作",
            align: "center",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              (scope.row.isAdd)
                ? (_openBlock(), _createBlock(_component_e_button, {
                    key: 0,
                    size: "mini",
                    type: "warning",
                    plain: "",
                    onClick: ($event: any) => (onDelUser(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("移除")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_e_button, {
                    key: 1,
                    size: "mini",
                    onClick: ($event: any) => (onAddUser(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("添加")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createVNode(Pagination, {
        pageNo: paginationObj.pageNum,
        "onUpdate:pageNo": _cache[4] || (_cache[4] = ($event: any) => ((paginationObj.pageNum) = $event)),
        pageSize: paginationObj.pageSize,
        "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((paginationObj.pageSize) = $event)),
        total: paginationObj.totalCount,
        onPagination: getList
      }, null, 8, ["pageNo", "pageSize", "total"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})